var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDirectDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51 19.64 2.41 8.05c-.82-1.55-.55-3.35.67-4.6C4.3 2.2 6.1 1.9 7.66 2.68L10.9 4.3c.68.34 1.5.34 2.19 0l3.24-1.62c1.57-.78 3.37-.48 4.59.77 1.22 1.25 1.49 3.05.67 4.6l-6.1 11.59A3.93 3.93 0 0 1 12 21.75a3.93 3.93 0 0 1-3.49-2.11zM4.15 4.5c-.6.62-1.03 1.69-.42 2.85l6.1 11.59c.43.82 1.24 1.31 2.16 1.31.92 0 1.73-.49 2.16-1.31l6.1-11.59c.61-1.16.19-2.24-.42-2.85-.6-.61-1.66-1.06-2.84-.48l-3.24 1.62c-1.11.55-2.42.55-3.53 0L6.99 4.02c-.38-.19-.76-.27-1.11-.27-.71 0-1.33.34-1.73.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDirectDown);
export default __webpack_public_path__ + "static/media/vuesax-outline-direct-down.f8449ca5a2ea1a749de24ffac27ae8f4.svg";
export { ForwardRef as ReactComponent };